import type { ReactNode } from "react";

export interface FieldProps {
  /** Beschriftung, bereits übersetzt. */
  label: ReactNode;
  /** Hinweis unter dem Feld. */
  hint?: ReactNode;
  /** id des Eingabeelements, damit die Beschriftung es fokussiert. */
  htmlFor?: string;
  children: ReactNode;
}

/**
 * Beschriftetes Feld außerhalb von Antd-Formularen (Kit, aus my-vitalteam übernommen 14.10.2026):
 * Beschriftung oben, Feld, Hinweis darunter. In `Form` bleibt `Form.Item` zuständig.
 */
export function Field({ label, hint, htmlFor, children }: FieldProps) {
  return (
    <div className="ck-form-field">
      <label className="ck-form-field-label" htmlFor={htmlFor}>
        {label}
      </label>
      {children}
      {hint ? <span className="ck-form-field-hint">{hint}</span> : null}
    </div>
  );
}
